import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { PureComputed, Subscribable } from 'knockout';
import { CurrentUserManager } from 'managers/currentUser';
import { IWCCStorageManager } from 'managers/iStorage';
import { TopicManager } from 'managers/topic';
import TopicVotesManager from './topic/votes';

export interface TopicVotesManagerConfig {
    topicId: string
}

@injectable()
export default class IdeationManager {
    stage: Subscribable<number>

    availableUpvotes: Subscribable<number>
    availableDownvotes: Subscribable<number>

    hasUpvotes: Subscribable<boolean>
    hasDownvotes: Subscribable<boolean>

    isIdeation: Subscribable<boolean>
    isRatingStage: Subscribable<boolean>
    isVotingStage: Subscribable<boolean>
    isDoneVoting: Subscribable<boolean>

    isReady: Subscribable<boolean>

    constructor(
        @inject(wccModules.managerConfig) { topicId }: TopicVotesManagerConfig,
        @inject(wccModules.storage) storage: IWCCStorageManager
    ) {
        const userManager = storage.get(CurrentUserManager, { discussionId: settings.discussionId });
        const user = userManager.pluck(m => m.person);
        const isRegularUser = user.pluck(u => u.isRegular, false);

        const topicManager = storage.get(TopicManager, { topicId });
        const topic = topicManager.pluck(m => m.topic);
        this.isIdeation = topic.pluck(t => t.isIdeation, false);
        this.stage = topic.pluck(t => t.ideationStage, 0);
        const upvotesCount = topic.pluck(t => t.ideationUpvotes, 0);
        const downvotesCount = topic.pluck(t => t.ideationDownvotes, 0);

        const votesManager = storage.get(TopicVotesManager, { topicId: topicId });
        const loadingVotes = votesManager.pluck(m => m.loading, true);
        const votes = votesManager.pluck(m => m.votes, []);

        const personUpvotes = votes.filter(v => v.value() > 0);
        const personDownvotes = votes.filter(v => v.value() < 0);

        const usedUpvotes = personUpvotes.reduce((r, v) => r + v.value(), () => 0);
        this.availableUpvotes = ko.pureComputed(() => isRegularUser() ? upvotesCount() - usedUpvotes() : 0);

        const usedDownvotes = personDownvotes.reduce((r, v) => r - v.value(), () => 0);
        this.availableDownvotes = ko.pureComputed(() => isRegularUser() ? downvotesCount() - usedDownvotes() : 0);

        this.hasUpvotes = this.availableUpvotes.is(count => count > 0);
        this.hasDownvotes = this.availableDownvotes.is(count => count > 0);

        this.isRatingStage = ko.pureComputed(() => this.stage() === enums.IdeationStages.IdeaRating.value);
        this.isDoneVoting = this.availableUpvotes.is(0);

        this.isVotingStage = ko.pureComputed(() => this.isIdeation() && isRegularUser() && this.isRatingStage() && !this.isDoneVoting());

        this.isReady = ko.pureComputed(() => !this.isIdeation() || user() != undefined && topic() != undefined && !loadingVotes());
    }    
}